import jwt_decode from 'jwt-decode';
import ApiClient from '../../../../utils/api/ApiClient';
import { createSlice } from '@reduxjs/toolkit';
import Api from 'utils/api/Api';
import moment from 'moment';
import { toast } from 'react-toastify';

const initialState = {
    authenticated: false, id: null, userid: null, name: null, grade: null,
    type: null, message: null, resetPassword: null, aboutGrade: null, isAdmin: false,
    restricted: null,
    isStanBy: 'N'
};
const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        authenticated: (state, action) => {
            return { ...state, ...action.payload, authenticated: true };
        },
        unauthenticated: (state) => initialState,
    }
});

export default authSlice.reducer;
export const authActions = authSlice.actions;

export const authenticated = (authData) => {
    return function (dispatch) {
        if (Math.abs(moment().diff(moment(authData.now).add(1, 'minutes'), 'hours')) > 10) {
            toast.error('기기의 날짜/시간을 확인해주세요. ' + moment().format('LLL'));
            return;
        }

        if (moment().diff(moment(authData.passwordUpdateTime), 'day') > 365) {
            toast.warning('1년 이상 같은 비밀번호를 사용중입니다.계정 보호를 위해 비밀번호를 변경해 보세요.');
        }


        let tokenData = jwt_decode(authData?.token);

        sessionStorage.setItem('user', authData.token);
        sessionStorage.setItem('refreshToken', authData.refreshToken);
        sessionStorage.setItem('sseToken', authData.sseToken);
        sessionStorage.setItem('expireAt', tokenData.exp);

        dispatch(authActions.authenticated(authData.user));

    };
}

export const signoutAction = () => {
    return (dispatch) => {
        if (sessionStorage.getItem("user") === undefined) return false;
        sessionStorage.removeItem("user");
        sessionStorage.removeItem("refreshToken");
        sessionStorage.removeItem("sseToken");

        dispatch(authActions.unauthenticated());
        return true;
    };
}

export const initialAuthenicate = () => {
    return function (dispatch, getState) {
        Api.get('/api/auth/info').then(res => {
            if (res?.data) {
                if (getState().school.code !== res.data.schoolCode) {
                    dispatch(authActions.unauthenticated());
                } else {
                    dispatch(authActions.authenticated(res.data));
                }
            }
        }).catch(e=>{
            console.log(e);
        });
    }
}


let cancelUserJoin;
export function userJoin(userData) {
    return async function (dispatch) {
        if (cancelUserJoin !== undefined) cancelUserJoin();
        const { promise, cancel } = ApiClient({
            url: '/api/user/join',
            data: userData
        });

        cancelUserJoin = cancel;
        return promise
    };
}// userJoin